import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartValueDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    badge: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    description: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: ChartValueDynamicStyleType) => {
    const styles = {
        container: {
            columnGap: spaces.spacingSm,
            rowGap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
